module.exports = __webpack_public_path__ + "static/media/lettering.8cc6edc6.gif";